import PropTypes from "prop-types";
import { CHECK_IN_LANG } from "../hooks/useCheckInLanguage";

const label = PropTypes.string;

/** Cadenas de copy usadas en formularios cliente (ultrasound / massage / DNA). */
export const clientFormCopyPropType = PropTypes.shape({
  firstName: label,
  lastName: label,
  email: label,
  spousePartner: label,
  addressLine1: label,
  addressLine2: label,
  city: label,
  state: label,
  zipCode: label,
  phoneCel: label,
  dateOfBirth: label,
  physicianName: label,
  physicianPhone: label,
  doctorFacilities: label,
  pregnancyProblem: label,
  ifYesExplain: label,
  aboutUs: label,
  selectAnOption: label,
  yes: label,
  no: label,
  termsAndConditions: label,
  waiver: label,
  agreeTermsUse: label,
  agreeWaiver: label,
  babyAcademyIntro: label,
  babyAcademyYes: label,
  babyAcademyNo: label,
  formHeaderWelcome: label,
  formHeaderToSite: label,
  formHeaderAppointment: label,
  formHeaderRequiredServices: label,
  formHeaderFillForm: label,
  dueDate: label,
  howManyUltrasounds: label,
  lastUltrasound: label,
  resultsNormal: label,
  ifAbnormalExplain: label,
  howManyMassages: label,
  lastMassage: label,
  anyProblems: label,
  ifProblemsExplain: label,
}).isRequired;

export const clientFormLanguagePropTypes = {
  lang: PropTypes.oneOf([CHECK_IN_LANG.EN, CHECK_IN_LANG.ES]).isRequired,
  setEnglish: PropTypes.func.isRequired,
  setSpanish: PropTypes.func.isRequired,
  copy: clientFormCopyPropType,
};
